<template>
  <div>
    <div class="row">
      <div
        v-for="certificate in certificates"
        :key="certificate.id"
        :class="`${cols}`"
      >
        <CourseBasicCertifiedItem :certificate="certificate"/>
      </div>
    </div>
  </div>
</template>

<script>
import CourseBasicCertifiedItem from '../../course/CourseBasicCertifiedItem.vue'

export default {
  components: { 
    CourseBasicCertifiedItem,
  },

  props: {
    certificates: { type: Array, required: true },
    type: { type: String, default: 'desktop' }
  },

  computed: {
    cols () {
      const cols = {
        desktop: 'col-md-6 col-12',
        mobile: 'col-12'
      }
      
      return cols[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/mixins";

  .row { @include children-gap(15px) }
</style>